import { useEffect, useState } from 'react';

/**
 * Custom hook for watching and returning an elements width
 * @param {Ref} ref - Ref type element
 */
export default function useElementWidth(ref) {
  const [width, setWidth] = useState(null);

  useEffect(() => {
    if (ref.current.clientWidth !== width) {
      setWidth(ref.current.clientWidth);
    }
    const listener = () => {
      setWidth(ref.current.clientWidth);
    };
    window.addEventListener('resize', listener);
    return () => window.removeEventListener('resize', listener);
  }, [width, ref]);

  return width;
}
